// Libs
import React, { Component } from 'react'
import Dropzone from 'react-dropzone';
import Isvg from 'react-inlinesvg'
import _ from 'lodash'

// CSS
import "./styles.scss"

// Component/Container
import CloseIcon from "../../../../components/CloseIcon"

class NewInicialPageFile extends Component {
  state = {
    files: [],
    filesSize: 0,
    filesError: '',
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = nextProps.input

    if (!value) {
      this.setState({
        files: [],
      })
    }
  }

  addFiles = (acceptedFiles, rejectedFiles) => {
    const { input, multiple } = this.props
    const { files, filesSize } = this.state
    const addFiles = files.concat(acceptedFiles)
    let acceptedFilesSize = 0
    let rejectedFilesSize = 0

    if (!_.isEmpty(acceptedFiles)) {
      acceptedFiles.forEach(file => {
        acceptedFilesSize += file.size

        if (file !== 'application/pdf')
          this.setState({
            filesError: 'Somente é possível inserir arquivos .pdf'
          })
      })
    }

    if (!_.isEmpty(rejectedFiles)) {
      rejectedFiles.forEach(file => {
        rejectedFilesSize += file.size

        if (file !== 'application/pdf')
          this.setState({
            filesError: 'Somente é possível inserir arquivos .pdf'
          })
      })
    }

    if (multiple) {
      if (filesSize + acceptedFilesSize + rejectedFilesSize <= 10000000) {
        this.setState({
          files: addFiles,
          filesSize: filesSize + acceptedFilesSize,
          filesError: ''
        })

        input.onChange(addFiles)
      } else {
        this.setState({
          filesError: 'Não é possível inserir mais que 10MB'
        })
      }
    }

    if (!multiple) {
      if (rejectedFilesSize <= 2000000) {
        this.setState({
          files: acceptedFiles,
          filesError: ''
        })

        input.onChange(addFiles)
      } else {
        this.setState({
          filesError: 'Não é possível inserir mais que 10MB'
        })
      }
    }
  }

  removeFile = (e) => {
    const { input } = this.props
    const { files, filesSize } = this.state

    const removeFiles = files
      .filter((file, index) => {
        if (index !== Number(e.target.id)) {
          return file
        }
        return null
      })

    this.setState({
      files: removeFiles,
      filesSize: filesSize - files[e.target.id].size,
      filesError: ''
    })

    if (removeFiles.length === 0) {
      input.onChange(null)
    } else {
      input.onChange(removeFiles)
    }

    e.stopPropagation()
  }

  render() {
    const { input: { onChange, ...input }, meta: { touched, error }, label, multiple, img, gutter } = this.props
    const { files, filesError } = this.state

    const fileStyle = {
      margin: `${gutter / 2}px 0px`
    }

    return (
      <div style={fileStyle} className="new-inicial-page-file">
        <div className="new-inicial-page-file__label">{label}</div>
        <Dropzone
          {...input}
          multiple={multiple}
          accept={{ "application/pdf": ['.pdf'] }}
          maxSize={multiple ? 10000000 : 2000000}
          onDrop={this.addFiles}>
          {({ getRootProps, getInputProps }) => {
            return (
              <section className={"new-inicial-page-file__dropzone"} {...getRootProps()}>
                <input {...getInputProps()} />
                {files && (
                  <ul className="new-inicial-page-file__files">
                    {files.map((file, i) =>
                      <li key={i} className="new-inicial-page-file__file">
                        <span className="new-inicial-page-file__name">{file.name}</span>
                        <CloseIcon id={i} width={15} onClick={this.removeFile} />
                      </li>
                    )}
                  </ul>
                )}
                <Isvg
                  src={img}
                  className={_.isEmpty(files) ?
                    "new-inicial-page-file__img" :
                    "new-inicial-page-file__img new-inicial-page-file__img--lighter"} />
                <div className="new-inicial-page-file__button new-inicial-page-file__button--computer">
                  Adicionar {multiple ? 'anexos' : 'inicial'}
                </div>
                {!multiple &&
                  <div className="new-inicial-page-file__text">
                    Somente arquivo
                    <span className="new-inicial-page-file__text--colored"> .pdf </span>
                    com no máximo
                    <span className="new-inicial-page-file__text--colored"> 2MB</span>.
                  </div>
                }
                {multiple &&
                  <div className="new-inicial-page-file__text">
                    Somente arquivos
                    <span className="new-inicial-page-file__text--colored"> .pdf </span>
                    totalizando no máximo
                    <span className="new-inicial-page-file__text--colored"> 10MB</span>.
                  </div>
                }
              </section>
            )
          }}
        </Dropzone>
        {(filesError || (touched && error)) && <p className="new-inicial-page-file__err">{filesError || error}</p>}
      </div>
    )
  }
}

export default NewInicialPageFile
